import React, { useEffect, useState, } from 'react'
import { Helmet, } from "react-helmet"
import Loading from '../layouts/Loading'
import { appName, appDescription, appSlogan, } from '../../constants'
import GetStartedComponent from './GetStartedComponent'

export default function HomeComponent() {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(false)
  }, [])

  if (loading) {
    return <>
      <Helmet>
        <title>Home - {appName}</title>
        <meta name="title" content={`Home - ${appName}`}/>
        <meta name="description" content={appDescription}/>
      </Helmet>
      <div className="container text-center mt-9 mb-8">
        <Loading />
      </div>
    </>
  }

  return (
    <>
      <Helmet>
        <title>Home - {appName}</title>
        <meta name="title" content={`Home - ${appName}`}/>
        <meta name="description" content={appDescription}/>
      </Helmet>
      <section className="py-7 py-lg-10">
        <div
          className="bg-holder bg-size"
          style={{
            backgroundImage: "url(/assets/img/illustration/2.png)",
            backgroundPosition: "left top",
            backgroundSize: "contain"
          }}
        ></div>
        <div
          className="bg-holder d-none d-xxl-block hero-bg"
          style={{
            backgroundImage: "url(/assets/img/joystick/home/background.png)",
            backgroundPosition: "right top",
            backgroundSize: "contain",
          }}
        ></div>
        <div className="container">
          <div className="row align-items-center h-100 justify-content-center justify-content-lg-start">
            <div className="col-md-9 col-xxl-5 text-md-start text-center py-6 pt-8">
              <h1
                className="fs-4 fs-md-5 fs-xxl-4"
                // data-zanim-xs='{"delay":0.3}'
                // data-zanim-trigger="scroll"
              >
                {appSlogan}
              </h1>
              <p
                className="fs-1"
                // data-zanim-xs='{"delay":0.5}'
                // data-zanim-trigger="scroll"
              >
                {appDescription}
              </p>
              <div
                className="d-flex flex-column flex-sm-row justify-content-center justify-content-md-start mt-5"
                // data-zanim-xs='{"delay":0.5}'
                // data-zanim-trigger="scroll"
              >
                <a
                  className="btn btn-sm joystick-btn me-1"
                  href="/user/register"
                  role="button"
                >
                  Get started
                </a>
                {/* <a
                  className="btn btn-sm btn-default"
                  href="#"
                  role="button"
                >
                  Questions? Talk to our team<i className="fas fa-arrow-right ms-2"></i>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <GetStartedComponent/>
    </>
  )
}
